import { ButtonProps } from "@mui/material";
import { ButtonTypeMap } from "@mui/material/Button/Button";
import { SyntheticEvent } from "react";
import TextButton from "@/components/common/buttons/textButton";

type ShowMoreButtonProps = ButtonProps<
  ButtonTypeMap["defaultComponent"],
  {
    onClick: (e: SyntheticEvent) => void;
    isExpanded: boolean;
    showLabel?: string;
    hideLabel?: string;
  }
>;

function ShowMoreButton({
  isExpanded,
  showLabel = "Show more",
  hideLabel = "Show less",
  onClick,
  ...rest
}: ShowMoreButtonProps) {
  return (
    <TextButton onClick={onClick} {...rest}>
      {!isExpanded ? showLabel : hideLabel}
    </TextButton>
  );
}

export default ShowMoreButton;
